
// тестовый дескриптор 
export const TestTable = {
    id: 'test_table',
    api: 'defBridge',
    title: 'test_table',
    showCheckboxes: false,
    pdf:true,    
    items: [{id:'id'},
            {id: 'size', title: 'Размер', formatter: "selectFormat", select: ['42-44', '44-46', '46-48']}, 
            {id: 'image' , title: 'Изображение', formatter: "imageFormat"},
            {id: 'text', formatter: "moreTextFormat", pdf: true},
            {id:'barcode', formatter: "barCodeFormat"},
            {id:'qrcode', formatter: "qrCodeFormat"},
            {id:'rt', title: 'Время',pdf: true},
            {id:'data', formatter: "moreTextFormat"},
          ],
  };

  export const TestTable2 = {
        id: 'test_table2',
        api: 'defBridge',
        title: 'test_table2',
        showCheckboxes: true,
        items: [{id:'id'},
                {id: 'text', formatter: "moreTextFormat"},
                {id:'data', formatter: "moreTextFormat"},
              ],
      };